import { ROLE_TYPES } from "features/administration/constants";

/**
 * Shared constants for the MCAP robot-log list.
 */

// A file is "reachable" when at least one of its replicas is available on
// storage the platform can access; unreachable files (bytes only on the
// org's own storage or the robot) cannot be downloaded from here.
export const isReachable = (record) => record.reachable !== false;

// Replica-status → AntD Tag color for the Replicas column.
export const REPLICA_STATUS_COLORS = {
  available: "green",
  pending: "gold",
  copying: "blue",
  failed: "red",
  deleting: "volcano",
};

export const UPLOAD_STATE_COLORS = {
  pending: "default",
  uploading: "processing",
  uploaded: "success",
  failed: "error",
};

// Upload states the list can be filtered on (UploadState in the
// raasdata-service model), in the order a file moves through them.
export const UPLOAD_STATE_OPTIONS = [
  { value: "pending", label: "Pending" },
  { value: "uploading", label: "Uploading" },
  { value: "uploaded", label: "Uploaded" },
  { value: "failed", label: "Failed" },
];

export const PROCESSING_STATE_COLORS = {
  pending: "default",
  running: "processing",
  done: "success",
  failed: "error",
};

// Processing states the list can be filtered on (ProcessingState in the
// raasdata-service model), in the order a file moves through them.
export const PROCESSING_STATE_OPTIONS = [
  { value: "pending", label: "Pending" },
  { value: "running", label: "Running" },
  { value: "done", label: "Done" },
  { value: "failed", label: "Failed" },
];

// Recording states the list can be filtered on (RecordingState in the
// raasdata-service model).
export const RECORDING_STATE_OPTIONS = [
  { value: "init", label: "Init" },
  { value: "recording", label: "Recording" },
  { value: "stopped", label: "Stopped" },
  { value: "failed", label: "Failed" },
];

export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];
export const DEFAULT_PAGE_SIZE = 20;

// Table density → AntD Table `size`. Persisted so the choice survives reloads.
export const DENSITY_STORAGE_KEY = "mcapLogs.density";
export const DENSITY_OPTIONS = [
  { label: "Compact", value: "small" },
  { label: "Default", value: "middle" },
];
export const DEFAULT_DENSITY = "middle";

// Sort keys the backend accepts (MCAPLogSortField in the raasdata-service
// schema). Anything outside this set is ignored when parsing the URL.
export const SORT_FIELDS = [
  "uploaded_at",
  "filename",
  "file_size",
  "duration_seconds",
  "message_count",
  "recording_start_time",
  "robot_id",
];
export const DEFAULT_SORT_BY = "uploaded_at";
export const DEFAULT_SORT_ORDER = "descend";

// Org roles (any of) that unlock the Robot Log Data pages (/robot-logs/**) and
// their sidebar entry. Superusers bypass this check — see shared/utils/orgRoles.js.
export const ROBOT_LOGS_REQUIRED_ORG_ROLES = [ROLE_TYPES.LOG_MANAGER];

// Routes of the Robot Log Data pages, registered in app/App.js; the dashboard
// links its chart items into the list page with these.
export const ROBOT_LOGS_DASHBOARD_PATH = "/robot-logs";
export const ROBOT_LOGS_LIST_PATH = "/robot-logs/list";
